import { z } from 'zod';

export const TimedWordSchema = z.object({
  word: z.string(),
  start: z.number().gte(0),
  end: z.number().gte(0),
});
export type TimedWord = z.infer<typeof TimedWordSchema>;

export const VoiceOverTimingSchema = z.array(TimedWordSchema);
export type VoiceOverTiming = z.infer<typeof VoiceOverTimingSchema>;

export const TimedScriptSchema = z.object({
  audio: z.instanceof(Buffer),
  text: z.string(),
  timing: VoiceOverTimingSchema,
});
export type TimedScript = z.infer<typeof TimedScriptSchema>;
